import React, { useEffect, useState } from 'react';
import SideBar from './SideBar';
import TopNav from './TopNav';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS

const WeeklySalesReports = () => {
    const [salesData, setSalesData] = useState([]);

    useEffect(() => {
        // Simulate fetching data (replace with your data fetching logic)
        const fetchData = async () => {
            const data = [
                { id: 1, product: "Product A", quantity: 70, total: 700 },
                { id: 2, product: "Product B", quantity: 60, total: 600 },
                { id: 3, product: "Product C", quantity: 50, total: 500 },
            ];
            setSalesData(data);
        };

        fetchData();
    }, []);

    return (
        <div className="d-flex">
            <SideBar />
            <div className="flex-grow-1 d-flex justify-content-end p-3" style={{ maxWidth: '80%', marginLeft: 'auto' }}>
                <div style={{ width: '100%', textAlign: 'right' }}>
                    <TopNav />
                    <h4 className="mb-4 text-center" style={{marginTop: 65}}>Weekly Sales Report</h4>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Product</th>
                                    <th scope="col">Quantity Sold</th>
                                    <th scope="col">Total Sales ($)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {salesData.map((sale) => (
                                    <tr key={sale.id}>
                                        <th scope="row">{sale.id}</th>
                                        <td>{sale.product}</td>
                                        <td>{sale.quantity}</td>
                                        <td>{sale.total}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeeklySalesReports;